import { UserAccessPolicyResponse } from "../../../api";
import { DataModel } from "../../../models/data-model";
import { Location, toLocations } from "./utils";

export type AccessPoliciesItem = UserAccessPolicyResponse & {
  locations?: Location[];
};

/**
 * Access policies of all users, joined onto the users table by
 * `connected_user.uuid` (see `AdminConsole.policyForUser`) and edited through
 * the per-user permissions dialog.
 */
export class AccessPolicies extends DataModel<AccessPoliciesItem> {
  readonly idAttr = "uuid";

  init() {
    this.data = this.data.map((item) => ({
      ...item,
      locations: toLocations(item.regions),
    }));
    super.init();
  }
}
